module.exports = __webpack_public_path__ + "media/markers/aton_gry-1e08bdbc.svg";